import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ScanBarcode: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path d="M4 18v-4H2v4c0 1.1.9 2 2 2h4v-2H4zM4 10V6h4V4H4c-1.1 0-2 .9-2 2v4h2zM22 6c0-1.1-.9-2-2-2h-4v2h4v4h2V6zM20 14v4h-4v2h4c1.1 0 2-.9 2-2v-4h-2z" />
    <path d="M5 9v6h3V9H5zM14 15V9h3v6h-3zM11 15V9h2v6h-2zM9 15V9h1v6H9zM18 15V9h1v6h-1z" />
  </SvgIcon>
)
